import React, { Component } from "react";
import { Panel, PanelGroup } from "react-bootstrap";

class Highlight extends Component {
    constructor() {
        super();
        this.FRAGMENT_SIZE_LIMIT = 100;        
    }

    renderHighlightContent(content) {
        let isFragment = content.length >= this.FRAGMENT_SIZE_LIMIT;
        let neutralisedHighlightedContent = this.highlightMatches(
            this.neutraliseHtml(content.trim())
        );
        let displayReadyContent = isFragment
            ? this.indicateFragment(neutralisedHighlightedContent)
            : neutralisedHighlightedContent;
        return { __html: displayReadyContent };
    }

    neutraliseHtml(content) {
        //first ampersand, then less-than
        let neutralised = content.replace(/&/g, "&amp;").replace(/</g, "&lt;");
        return neutralised;
    }

    highlightMatches(content) {
        return content
            .replace(
                /\[\[webfinery:match:begin\]\]/g,
                '<span style="font-weight: normal; padding: 1px 2px 1px 2px; solid #99dd99; border: 2px solid #99dd99">'
            )
            .replace(/\[\[webfinery:match:end\]\]/g, "</span>");
    }

    indicateFragment(content) {
        //return "..." + content + "...";
        return content;
    }

    getHighlightTypeLabel(key) {
        //const keyText = key.replace(/\./g, '&nbsp;');
        const keyText = this.getLabelForKey(key);
        const label = "<span style='color: #bbbbbb; font-weight: normal; text-transform: uppercase; padding: 0px 2px 0px 2px; border: 1px solid #cccccc;'>" +
            keyText +
            "</span>";
        return { __html: label };
    }

    getLabelForKey(key) {
        //TODO could be more precise (which meta tags?)
        let keyHead = key.split(".")[0].toLowerCase();
        if (keyHead === "content") return "HTML & JavaScript";
        if (keyHead === "headerfields") return "Server HTTP Header";
        if (keyHead === "metatags") return "Meta Tags";
        if (keyHead === "script") return "JavaScript";
        if (keyHead === "title") return "Title";
        return key;
    }

    typeLabel(key) {
        return this.props.showHighlightedFieldLabel
            ? <span dangerouslySetInnerHTML={this.getHighlightTypeLabel(key)} />
            : null;
    }


    render() {
        return (
            <div>
            	<PanelGroup>
	                {!this.props.data
	                    ? null
	                    : Object.keys(this.props.data).map((key, index) => (
	                    	<Panel header={this.getLabelForKey(key)} eventKey={index} key={index} className={this.getLabelForKey(key)}>
	                          {this.props.data[
	                              key
	                          ].map(content => (
	                              <div key={content}>
	                                  <span
	                                      dangerouslySetInnerHTML={this.renderHighlightContent(
	                                          content
	                                      )}
	                                  />
	                              </div>
	                          ))}
	                        </Panel>
	                      ))}
                </PanelGroup>
            </div>
           );
    }
}

export default Highlight;


// WEBPACK FOOTER //
// ./src/Highlight.js